enum DDAConciliationOriginType {
  DDA = 'DDA',
  ERP = 'ERP',
  INN = 'INN',
}

export default DDAConciliationOriginType;
